<template>
  <div class="section">
    <NewsEditor :news="news" @submitted="createNews" />
  </div>
</template>

<script>
import NewsEditor from '@/components/editNews/NewsEditor.vue';

export default {
  name: 'NewNews',
  components: {
    NewsEditor,
  },
  data() {
    return {
      news: {
        title: '',
        text: '',
        sidebox_enabled: false,
        sidebox_text: '',
        visible: true,
        category_id: null,
        created_at: new Date().getTime(),
      },
    };
  },
  methods: {
    createNews(payload) {
      this.$store.dispatch('news/CREATE', payload);
    },
  },
};
</script>

<style>
</style>
